/**
 * BugWorkflowEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { BugStateEntity } from "../BugStateEntity";
import { BugTransitionEntity } from "../BugTransitionEntity";
import { BugWorkflowEntity } from "../BugWorkflowEntity";
declare global {
    interface EntityTypeMap {
        BugWorkflow: BugWorkflowEntity;
    }
}
export abstract class BugWorkflowGeneratedEntity extends BaseEntity {
    public abstract bugWorkflowId: string;
    public abstract templateId: string | null;
    public abstract project: ProjectEntity;
    public abstract readonly bugGroups: ReadonlyArray<BugGroupEntity>;
    public abstract readonly bugStates: ReadonlyArray<BugStateEntity>;
    public abstract readonly bugTransitions: ReadonlyArray<BugTransitionEntity>;
}
